// extracted by mini-css-extract-plugin
export default {"popover":"Connected_popover__Nzcyj","link":"Connected_link__hXd7P","mobileItem":"Connected_mobileItem__6GSR5"};